module.exports = __webpack_public_path__ + "static/media/engrafis-logo-2020.a9c0752d.png";